import React, { useContext } from "react";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import { Api, getParam, useAuthProvider, Loader, callApi, DataContext, VerifiedEntity, User } from "@cloudpremise/portal_core";
import { useNavigate } from "react-router-dom";
import { LoginWithLinkState } from "../types";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

// @mui material components
import Grid from "@mui/material/Grid";

const LoginWithLink = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const secureLink = getParam("secureLink");
    const [controller, dispatch] = useMaterialUIController();
    const dataProvider = useContext(DataContext);
    let heading = "Enter Your Email Address to Continue";
    let loadingLinkInfo = false;
    let footer = "Unauthenticated Screen";
    if(typeof(secureLink) === "string" && secureLink.length > 0 && secureLink !== "null"){
        heading = "Please wait while we verify your secure link";
        loadingLinkInfo = true;
        footer = "Authenticated Screen";
    }
    const defaultState = {
        email: "",
        loading: loadingLinkInfo,
        errorMessage: null,
        heading: heading,
        loadLink: loadingLinkInfo,
        loadingLinkInfo: loadingLinkInfo,
        footer: footer,
        verifiedEntity: null,
        checkEmail: false,
        searchText: "",
        sortColumn: 'Id',
        sortColumnDirection: {
			Id: 'desc',
		},
        items: [],
        selection: [],
        redirect: false
    };

    const [state, setState] = React.useReducer((state: LoginWithLinkState, newState: Partial<LoginWithLinkState>) => ({
        ...state,
        ...newState
    }), defaultState);

    const navigate = useNavigate();
    React.useEffect(() => {
        if(state.redirect){
            return navigate("/home"+window.location.search, { replace: true });
        }
        const verifiedEntity = localStorage.getItem("verified_entity");
        if(authorized && authType !== "link"){
            return navigate("/home"+window.location.search, { replace: true });
        }
        if(authorized && verifiedEntity !== null){
            return navigate("/home"+window.location.search, { replace: true });
        }

        if(!state.loadLink){
            return;
        }
        loadSecureLink();
    });

    function handleChange(e, name){
        setState({
            [name]: e.target.value,
        });
    }
    function onSubmit(e){
        e.preventDefault();
        const requestData = {
            email: state.email,
            // ipAddress: "127.0.0.1",
            returnUrl: window.location.origin+props.basename
        };
        let headers = {};
        let method = 'POST';
        let route = '/v1/identity/verification/email/generate_link';

        const object: VerifiedEntity = {
            sObjectTypeName: "VerifiedEntity",
            url: route,
            method: method,
            headers: headers,
            data: requestData
        };

        callApi(dataProvider, object).then(async (response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            setState({
                loading: false,
                loadingLinkInfo: false,
                errorMessage: null,
                heading: result.message,
                checkEmail: true
            });
        }).catch((err) => {
            let errorMessage = null;
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                errorMessage = err.error;
            }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                errorMessage = err.message;
            }
            setState({
                checkEmail: false,
                loading: false,
                loadingLinkInfo: false,
                heading: "Unable to generate link. Please try again.",
                footer: "Failed Screen",
                errorMessage: errorMessage,
            });
        });

        setState({
            checkEmail: false,
            loading: true,
            errorMessage: null
        });
    }
    function loadSecureLink(){
        localStorage.removeItem("reactforce_logout");
        const requestData = {
            secureLink: secureLink,
        };
        let headers = {
            'x-user-identity': secureLink,
            'X-Salesforce-SIP': "127.0.0.1"
        };
        let method = 'POST';
        let route = '/v1/identity/verification/email/verify_link';
        const object: VerifiedEntity = {
            sObjectTypeName: "VerifiedEntity",
            url: route,
            method: method,
            headers: headers,
            data: requestData
        };

        callApi(dataProvider, object).then(async (response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            if(typeof(result) === "object" && result.hasOwnProperty("identity")){
                const verifiedEntity = result.identity;
                localStorage.setItem("identity_token", secureLink);
                localStorage.setItem("verified_entity", JSON.stringify(verifiedEntity));
                localStorage.setItem("login_type", "link");
                let heading = "You are recognized as "+verifiedEntity.given_name+" "+verifiedEntity.family_name+" with Id: "+verifiedEntity.sub;
                const user = new User(result.identity);
                setState({
                    loading: false,
                    loadingLinkInfo: false,
                    errorMessage: null,
                    heading: heading,
                    verifiedEntity: verifiedEntity,
                    email: verifiedEntity.email,
                    footer: "Case Management Screen",
                    redirect: true
                });
                dispatch({value: {user: user}, type: "UPDATE_STATE"});
            }else{
                setState({
                    loading: false,
                    loadingLinkInfo: false,
                    heading: "Your Link is Not Valid. Try Again",
                    footer: "Failed Screen",
                    errorMessage: result.message,
                });
            }
        }).catch((err) => {
            let errorMessage = null;
            if(typeof(err) === "object" && err.hasOwnProperty("error")){
                errorMessage = err.error;
            }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                errorMessage = err.message;
            }

            setState({
                loading: false,
                loadingLinkInfo: false,
                heading: "Your Link is Not Valid. Try Again",
                footer: "Failed Screen",
                errorMessage: errorMessage,
            });
        });

        setState({
            loading: false,
            loadLink: false,
            errorMessage: null
        });
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={7} lg={5} py={{ xs: 0, sm: 2 }} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    p={2}
                                    textAlign="left"
                                >
                                    <h3 style={{marginBottom: "15px"}}>{state.heading}</h3>
                                    <div className="slds-p-around_medium">
                                        {
                                            (state.verifiedEntity !== null && !state.loading) ?
                                                null
                                            :
                                            (state.loadingLinkInfo || state.loading) ?
                                                <Loader color="info" />
                                            :
                                            <>
                                                <MDBox mb={2}>
                                                    <MDInput
                                                        type="email"
                                                        label="Enter Your Email"
                                                        fullWidth
                                                        value={state.email}
                                                        onChange={(e) => handleChange(e, "email")}
                                                    />
                                                </MDBox>
                                                {
                                                    state.errorMessage !== null ?
                                                        <Stack mb={2}>
                                                            <Alert severity="error">{state.errorMessage}</Alert>
                                                        </Stack>
                                                    :
                                                        null
                                                }
                                                {
                                                    state.verifiedEntity === null ?
                                                        state.loading ?
                                                            <Loader color="info" />
                                                        :
                                                        state.checkEmail === false ?
                                                            <MDButton variant="gradient" color="info" onClick={(e) => onSubmit(e)} fullWidth>
                                                                Generate Secure One Time Link
                                                            </MDButton>
                                                        :
                                                        null
                                                    :
                                                    null
                                                }
                                            </>
                                        }
                                    </div>
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default LoginWithLink;